import React from 'react';
import styled from 'styled-components';
import BrandButton from 'UI/common/brandButton';
import { appStore } from 'store';
import { Agreements } from '../agreements';
import { useT } from '@hooks';

const Container = styled.div`
	margin-top: 16px;
`;

const AgreementsWrapper = styled.div`
	border-radius: 5px;
	border: 1px solid #DCDAE5;
	padding: 16px;
	margin-bottom: 16px;
`;

export function GetMyPlanBlock(props) {
	const { paymentStore } = appStore;
	const { T } = useT();
	const { animateButton = false } = props;

	function showPaymentModal() {
		const rootElement = document.querySelector('#root');
		rootElement.style.overflowY = 'hidden';
    if (rootElement) {
			rootElement.scrollTop = 0;
		}
		paymentStore.setPaymentModalVisible(true);
	}

	return (
		<Container>
			<AgreementsWrapper>
				<Agreements currency={'$'} />
			</AgreementsWrapper>
			<BrandButton
				data-test='open-payment-modal'
				onClick={showPaymentModal}
				animateButton={animateButton}
			>
				{T('get_my_plan')}
			</BrandButton>
			
		</Container>
	);
}